export default "__VITE_ASSET__CdGbuyDJ__"